document.addEventListener('DOMContentLoaded', () => {

    const toggleButtons = document.querySelectorAll('.table__button');
    const sortButton = document.querySelector('.sort-button');
    const tableBody = document.querySelector('tbody');
    const searchInput = document.getElementById('sponsor-table-search');
    const deleteButton = document.getElementById('searchDelete');

    // -- Helper: Sichtbare Textknoten hervorheben
    const highlightTextNodes = (element, term) => {
        const regex = new RegExp(`(${term})`, 'gi');
        const walk = node => {
            if (node.nodeType === Node.TEXT_NODE) {
                const val = node.nodeValue;
                if (val && val.toLowerCase().includes(term)) {
                    const span = document.createElement('span');
                    span.innerHTML = val.replace(regex, '<em>$1</em>');
                    node.replaceWith(...span.childNodes);
                }
            } else if (node.nodeType === Node.ELEMENT_NODE && !['SCRIPT', 'STYLE'].includes(node.tagName)) {
                [...node.childNodes].forEach(walk);
            }
        };
        walk(element);
    };

    // -- Helper: ursprünglichen Zellinhalt wiederherstellen
    const restoreOriginalContent = (row) => {
        row?.querySelectorAll('td, button').forEach(cell => {
            if (cell.dataset.original !== undefined) {
                cell.innerHTML = cell.dataset.original;
            } else {
                cell.dataset.original = cell.innerHTML;
            }
        });
    };

    // -- Detailzeilen-Toggles (Auf/Zu)
    const initToggleButtons = () => {
        toggleButtons.forEach(button => {
            button.addEventListener('click', () => {
                const rowId = button.getAttribute('aria-controls');
                const detailRow = document.getElementById(rowId);
                const isExpanded = button.getAttribute('aria-expanded') === 'true';

                button.setAttribute('aria-expanded', String(!isExpanded));
                detailRow.toggleAttribute('hidden');
                button.classList.toggle('active');
            });
        });
    };

    // -- Sortierlogik (nach PLZ)
    const initSorting = () => {
        if (!sortButton || !tableBody) return;

        sortButton.addEventListener('click', () => {
            const direction = sortButton.getAttribute('data-sort-direction');
            const newDirection = direction === 'asc' ? 'desc' : 'asc';
            sortButton.setAttribute('data-sort-direction', newDirection);
            sortButton.setAttribute('aria-pressed', newDirection === 'desc' ? 'true' : 'false');

            const rows = Array.from(tableBody.querySelectorAll('.table__row--view'));

            rows.sort((a, b) => {
                const zipA = parseInt(a.querySelector('td[data-zip]')?.getAttribute('data-zip') || '0', 10);
                const zipB = parseInt(b.querySelector('td[data-zip]')?.getAttribute('data-zip') || '0', 10);
                return newDirection === 'asc' ? zipA - zipB : zipB - zipA;
            });

            const newRows = [];
            rows.forEach(viewRow => {
                const detailId = viewRow.querySelector('button')?.getAttribute('aria-controls');
                const detailRow = detailId ? document.getElementById(detailId) : null;
                newRows.push(viewRow);
                if (detailRow) newRows.push(detailRow);
            });

            newRows.forEach(row => tableBody.appendChild(row));
        });
    };

    // -- Suche mit Filter- und Highlight-Logik
    const initSearch = () => {
        if (!searchInput) return;

        searchInput.addEventListener('keyup', () => {
            const searchTerm = searchInput.value.toLowerCase().trim();
            const viewRows = Array.from(document.querySelectorAll('.table__row--view'));

            viewRows.forEach(viewRow => {
                const detailId = viewRow.querySelector('button')?.getAttribute('aria-controls');
                const detailRow = detailId ? document.getElementById(detailId) : null;
                const toggleButton = viewRow.querySelector('.table__button');

                if (detailRow) restoreOriginalContent(detailRow);

                const viewText = viewRow.textContent.toLowerCase();
                const detailText = detailRow ? detailRow.textContent.toLowerCase() : '';

                const matchesView = viewText.includes(searchTerm);
                const matchesDetail = detailText.includes(searchTerm);

                if (searchTerm === '') {
                    viewRow.style.display = '';
                    if (detailRow) {
                        detailRow.style.display = '';
                        detailRow.setAttribute('hidden', '');
                    }
                    if (toggleButton) {
                        toggleButton.setAttribute('aria-expanded', 'false');
                        toggleButton.classList.remove('active');
                    }
                } else if (matchesView || matchesDetail) {
                    viewRow.style.display = '';
                    if (detailRow) {
                        detailRow.style.display = '';
                        if (matchesDetail) {
                            detailRow.removeAttribute('hidden');
                            if (toggleButton) {
                                toggleButton.setAttribute('aria-expanded', 'true');
                                toggleButton.classList.add('active');
                            }
                            highlightTextNodes(detailRow, searchTerm);
                        } else {
                            detailRow.setAttribute('hidden', '');
                            if (toggleButton) {
                                toggleButton.setAttribute('aria-expanded', 'false');
                                toggleButton.classList.remove('active');
                            }
                        }
                    }
                } else {
                    viewRow.style.display = 'none';
                    if (detailRow) {
                        detailRow.style.display = 'none';
                    }
                }
            });

            const visibleRows = viewRows.filter(row => row.style.display !== 'none');
            const visibleCount = visibleRows.length;
        });
    };

    // -- Löschen-Button zum Zurücksetzen der Suche
    const initDeleteButton = () => {
        if (!deleteButton || !searchInput) return;

        deleteButton.addEventListener('click', () => {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('keyup'));
            searchInput.focus();
        });
    };

    // Initialisierung
    initToggleButtons();
    initSorting();
    initSearch();
    initDeleteButton();
});
